var AR = require('component/core/core.js');

if (!global.Intl) {
	require.ensure([
		'intl',
		'intl/locale-data/jsonp/en.js',
		'intl/locale-data/jsonp/ru.js'
	], function (require) {
		require('intl');
		require('intl/locale-data/jsonp/en.js');
		require('intl/locale-data/jsonp/ru.js');
	});
}

global.IntlMessageFormat = require('intl-messageformat');
require('intl-messageformat/dist/locale-data/en.js');
require('intl-messageformat/dist/locale-data/ru.js');

function getCurrentLocale() {
	switch (AR.lang) {
		case 'ru':
			return 'ru-RU';
		case 'en':
			return 'en-US';
		default:
			return 'ru-RU';
	}
}

export function getNumberFormat(options) {
	return new Intl.NumberFormat(getCurrentLocale(), options).format;
}



/** WEBPACK FOOTER **
 ** ./frontend/components/locale/locale.js
 **/